/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';
import { useHistory } from 'react-router';

import { Button, Modal } from '@mairistem/composants';

import ActeListeContainer from '@/components/Acte/Liste/ActeListeContainer';
import { TYPES_ACTES_IMPLEMENTES } from '@/constants';
import { baseUrlApp } from '@/routes';
import type { TypeActe } from '@/types';

interface ActeModalProps {
  open: boolean;
  title?: string;
  annee?: number | null;
  mois?: number | null;
  typeActe?: 'naissance' | 'reconnaissance' | 'mariage' | 'deces' | 'mention';
  onClose: () => void;
}

const ActeModal = (props: ActeModalProps) => {
  const { open, title, annee, mois, typeActe, onClose } = props;

  const history = useHistory();

  /**
   * Une ligne ouvre la fiche de son acte, et la modale se ferme : sans cela
   * elle restait ouverte par-dessus, le tableau de bord n'étant pas démonté.
   * Même règle que les listes de l'accueil (AD-12899) : décisions et PACS
   * n'ont pas de fiche dans cette application.
   */
  const handleSelect = (acte: Record<string, any>) => {
    const typeActeLigne = acte?.type_acte as TypeActe | undefined;
    const identifiant = acte?.identifiant ?? acte?.id;

    if (
      !typeActeLigne ||
      !TYPES_ACTES_IMPLEMENTES.includes(typeActeLigne) ||
      identifiant == null
    ) {
      return;
    }

    onClose();
    history.push(`${baseUrlApp}${typeActeLigne}/${identifiant}`);
  };

  return (
    <Modal open={open} onClose={onClose} size="large" closeIcon>
      <Modal.Header content={title} />
      {/* @ts-expect-error Type error */}
      <Modal.Content style={{ height: '700px' }}>
        <div style={{ height: '560px' }}>
          <ActeListeContainer
            annee={annee}
            mois={mois}
            typeActe={typeActe}
            stats
            modal
            onSelect={handleSelect}
          />
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button
          basic
          size="small"
          icon="close"
          content="Fermer"
          onClick={onClose}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ActeModal;
